if (!customElements.get('td-pdp-features')) {
  class TdPdpFeatures extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-td-ft-tab]')];
      if (!this.tabs.length) return;
      this.onClick = (event) => {
        const tab = event.target.closest('[data-td-ft-tab]');
        if (tab) this.select(tab.getAttribute('data-td-ft-tab'));
      };
      this.onKeyDown = (event) => {
        const tab = event.target.closest('[data-td-ft-tab]');
        if (!tab) return;
        const step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        event.preventDefault();
        const index = this.tabs.indexOf(tab);
        const next = this.tabs[(index + step + this.tabs.length) % this.tabs.length];
        this.select(next.getAttribute('data-td-ft-tab'));
        next.focus();
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeyDown);
    }

    disconnectedCallback() {
      if (this.onClick) this.removeEventListener('click', this.onClick);
      if (this.onKeyDown) this.removeEventListener('keydown', this.onKeyDown);
    }

    select(index) {
      this.tabs.forEach((tab) => {
        const selected = tab.getAttribute('data-td-ft-tab') === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });
      this.querySelectorAll('[data-td-ft-panel]').forEach((panel) => {
        panel.hidden = panel.getAttribute('data-td-ft-panel') !== index;
      });
      this.querySelectorAll('[data-td-ft-points]').forEach((list) => {
        list.hidden = list.getAttribute('data-td-ft-points') !== index;
      });
    }
  }

  customElements.define('td-pdp-features', TdPdpFeatures);
}
